export default __webpack_public_path__ + "static/media/Hot Wire MANIX.638fbc75.png";